import { Fetch } from 'lib/Fetch';

export function bankSimulator(simData) {
  return new Fetch('api_2')
    .url('/external/bankvision/simulador')
    .method('post')
    .data(simData)
    .send();
}

export function listPaymentPeriodicities() {
  return new Fetch('api_2')
    .url('/portal/front/payment-periodicity')
    .method('get')
    .portalToken()
    .send();
}

export function getMaximumGracePeriod(frequency) {
  return new Fetch('api_2')
    .url('/portal/front/maximum-grace-period')
    .method('post')
    .portalToken()
    .data({ frequency })
    .send();
}

export function downloadPaymentPlanSimulator(info) {
  return new Fetch('api_2')
    .url('/external/global/simulator-excel')
    .method('post')
    .portalToken()
    .data(info)
    .send();
}
